import useFetch from '../APIs/ValidateUser';
const ValidateUser = () => {
const {data:fetchedData,isLoading, error} = useFetch()

}

export default ValidateUser
